export enum StatusTag {
  error = 'error',
  info = 'info',
  success = 'success',
  warning = 'warning',
  neutral = 'neutral',
}
